// 枚举执行位置
export const ExecutionPlace = {
  PROXIMAL: [1, 4, 6], // 本地执行
  CLOUD: [2, 5]        // 云端执行
}

// 获取执行模式文本
export function executionMode(item) {
  const place = item.IFT_EXCUTE_PLACE

  if (ExecutionPlace.PROXIMAL.includes(place)) {
    return this.$t('ifttt.proximaldo')
  } else if (ExecutionPlace.CLOUD.includes(place)) {
    return this.$t('ifttt.clouddo')
  }
}
